import * as React from 'react'
import Text from '../../atoms/Text'
import LabelIcon from '../LabelIcon'
import { colors } from '@lmc/common/constants'
import Container from '../../atoms/Container'
import Icon from '../../atoms/Icon'
import { colours } from '../../config/theme'

const renderCustomIcon = (item: ItemType) => {
  const { icon, iconColour, iconBackgroundColour } = item

  const iconStyle = { ...styles.icon, backgroundColor: iconBackgroundColour }

  return (
    <div>
      <Icon color={iconColour} name={icon} size={20} style={iconStyle} />
    </div>
  )
}

const renderCustomText = (item: ItemType, _isLastItem?: boolean) => {
  const { title, subtitle, link } = item

  return (
    <div style={styles.customTextContainer}>
      <Text as="p1">{title}</Text>
      <Text
        style={styles.linkArticle}
        onClick={() => window.open(`${link}`, '_blank')}
      >
        {subtitle}
      </Text>
    </div>
  )
}

export type ItemType = {
  title: string
  subtitle: string
  icon: string
  iconBackgroundColour: string
  iconColour: string
  id: string
  link: string
}

export type IconLinkListProps = {
  backgroundColor?: string
  items: Array<ItemType>
  style?: React.CSSProperties
}

export default function IconLinkList({
  backgroundColor = colors.white,
  items,
  style,
}: IconLinkListProps) {
  return (
    <Container backgroundColor={backgroundColor} style={style}>
      <>
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1

          return (
            <LabelIcon
              key={item.id}
              renderCustomIcon={() => renderCustomIcon(item)}
              renderCustomText={() => renderCustomText(item, isLastItem)}
              style={index === 0 ? styles.firstLabelIcon : styles.labelIcon}
            />
          )
        })}
      </>
    </Container>
  )
}

const styles = {
  customTextContainer: {
    flexGrow: 1,
    paddingBottom: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  firstLabelIcon: {
    alignItems: 'flex-start',
  },
  icon: {
    padding: 12.5,
    borderRadius: 25,
    marginRight: 30,
    marginTop: 7,
  },
  labelIcon: {
    alignItems: 'flex-start',
    paddingTop: '24px',
  },
  lastCustomTextContainer: {
    flexGrow: 1,
  },
  linkArticle: {
    color: colours.neutral.color5,
    textDecoration: 'underline',
    fontSize: 12,
    cursor: 'pointer',
  },
} as const
